import * as stylex from '@stylexjs/stylex';
import { Link } from 'react-router-dom';
import { colors } from '@seeqdev/qomponents/colors.stylex';
import type { LinkProps } from 'react-router-dom';
import type { CellRendererValueProps } from '../cellRenderer.types';

export type TextLinkProps = CellRendererValueProps<string> &
  Pick<LinkProps, 'to' | 'target' | 'title' | 'rel'> & {
    truncateText?: boolean;
  };

/** Displays a text value as a router link to a caller-supplied destination. */
export const TextLink = ({ value, to, target, title, rel, truncateText = false }: TextLinkProps) => {
  if (!value) return null;

  return (
    <Link
      to={to}
      target={target}
      title={title}
      rel={rel}
      {...stylex.props(styles.link, truncateText && styles.truncatedText)}>
      {value}
    </Link>
  );
};

const styles = stylex.create({
  link: { color: colors.link, textDecoration: 'underline' },
  truncatedText: { display: 'block', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
});
